import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["submit"];

  validate() {
    var submit = this.submitTarget;
    if (submit.classList.contains('hidden')) {
      submit.classList.remove('hidden');
    }
  }

  setMatchId(event) {
    let match_id = event.currentTarget.dataset.matchId;
    var match = document.getElementById('match_id');
    match.value = match_id;
  }

  setTeam(event) {
    let team = event.currentTarget.dataset.team;
    let teamLogo = event.currentTarget.dataset.teamLogo;
    var teamName = document.getElementById("choosed-team");
    teamName.innerText = team;
    var logo = document.getElementById("team-logo");
    logo.src = teamLogo;
  }
}